// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__Lcbnq","sendOtp":"AuthorizeToLogin_sendOtp__4Xl4H"};